var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevicePictonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.34683,
    y: 2.38199,
    width: 36.7538,
    height: 36.7538,
    rx: 11.1859,
    fill: "#38AAE7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.34683,
    y: 2.38199,
    width: 36.7538,
    height: 36.7538,
    rx: 11.1859,
    stroke: "#F9F9F9",
    strokeWidth: 3.19598
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9853 18.6257L27.3873 17.8267C27.0917 17.6829 26.7242 17.7947 26.5804 18.0903C26.4285 18.394 26.5484 18.7535 26.844 18.8973L28.1144 19.5285V23.3557L25.1182 23.3637V15.166C25.1182 13.568 24.0475 12.769 22.7212 12.769H16.3292C15.0029 12.769 13.9323 13.568 13.9323 15.166V28.1497H12.7338C12.4062 28.1497 12.1345 28.4214 12.1345 28.7489C12.1345 29.0765 12.4062 29.3482 12.7338 29.3482H26.3167C26.6443 29.3482 26.9159 29.0765 26.9159 28.7489C26.9159 28.4214 26.6443 28.1497 26.3167 28.1497H25.1182V24.5622L28.7137 24.5542C29.0492 24.5542 29.3129 24.2826 29.3129 23.955V19.161C29.3129 18.9373 29.1851 18.7295 28.9853 18.6257ZM15.9297 16.6761C15.9297 15.5655 16.6089 15.166 17.4398 15.166H21.6186C22.4416 15.166 23.1207 15.5655 23.1207 16.6761V17.6589C23.1207 18.7615 22.4416 19.161 21.6106 19.161H17.4398C16.6089 19.161 15.9297 18.7615 15.9297 17.6509V16.6761ZM16.3292 20.9587H18.7262C19.0538 20.9587 19.3255 21.2304 19.3255 21.558C19.3255 21.8856 19.0538 22.1572 18.7262 22.1572H16.3292C16.0017 22.1572 15.73 21.8856 15.73 21.558C15.73 21.2304 16.0017 20.9587 16.3292 20.9587Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicePictonIcon);
export default __webpack_public_path__ + "static/media/devicePictonIcon.21432d9292ec05d6abfff6b697ca0fe9.svg";
export { ForwardRef as ReactComponent };